import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const graylog = defineConnector({
  identifier: "graylog",
  name: "Graylog",
  tagLine: "Log management and SIEM",
  logo,
  protocol: "http",
  tags: ["observability", "security"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: (app) =>
    basicAuth({
      username: app.secret.apiToken,
      password: "token",
    }),
  steps: [
    {
      title: "Get your Graylog API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Graylog instance and navigate to **System > Users** to create an API token for your user.",
        },
      ],
    },
    {
      title: "Enter your Graylog details",
      items: [
        {
          kind: "url",
          label: "Graylog URL",
          required: true,
          placeholder: "https://graylog.example.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your Graylog server.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
          helperText: "Use the token as username with 'token' as password.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/system`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    GRAYLOG_URL: baseUrl || "",
  }),
});
